import PropTypes from 'prop-types';
import SolicitorTitle from './solicitor-title';
import SolicitorPrimaryRadio from './solicitor-primary-radio';
import { Button, Icon } from '@evertrue/et-components';

const SolicitorItem = ({
  solicitor = {},
  titleState = 'visible',
  solicitorLimit = 1,
  handleChange = () => {},
  solicitorTitles = [],
}) => {
  return (
    <li className="proposal-form--list-row ">
      <SolicitorPrimaryRadio solicitor={solicitor} handleChange={handleChange} />
      <div className="proposal-form--solicitor-column">
        <SolicitorTitle
          titleState={titleState}
          solicitor={solicitor}
          solicitorTitles={solicitorTitles}
          handleChange={handleChange}
        />
        <Button type="simple" onClick={() => handleChange(solicitor.contact_id)} label="Remove solicitor">
          <Icon
            icon="cancel"
            className="proposal-form--cancel"
            title={`Remove solicitor, ${solicitor.name}`}
            size={1}
          />
        </Button>
      </div>
    </li>
  );
};

SolicitorItem.propTypes = {
  solicitor: PropTypes.shape({
    contact_id: PropTypes.number,
    name: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
  }),
  titleState: PropTypes.string,
  handleChange: PropTypes.func,
  solicitorLimit: PropTypes.number,
  solicitorTitles: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
};

export default SolicitorItem;
